// Cliente das rotas de sessão de upload (apps/trails/video_upload_urls.py).
// Só conversa com o NOSSO backend; os blocos vão direto pro storage.

import apiService from '@/services/api.service';
import type {
  AttachedVideo,
  CommitResponse,
  CreateSessionResponse,
  SasGrant,
  SessionDetailResponse,
} from './types';

const base = (lessonId: string) => `/admin/lessons/${lessonId}/video-uploads/`;

export const videoUploadApi = {
  /** Declara o arquivo e recebe a primeira credencial de escrita. */
  async create(lessonId: string, file: File): Promise<CreateSessionResponse> {
    const { data } = await apiService.post<CreateSessionResponse>(base(lessonId), {
      filename: file.name,
      size_bytes: file.size,
      content_type: file.type,
    });
    return data;
  },

  /** Status + quais blocos já chegaram. É o que torna a retomada possível. */
  async detail(lessonId: string, sessionId: string): Promise<SessionDetailResponse> {
    const { data } = await apiService.get<SessionDetailResponse>(
      `${base(lessonId)}${sessionId}/`
    );
    return data;
  },

  /** Nova credencial. O backend revalida a permissão aqui — é o ponto em que
   *  um curator despromovido perde o acesso em no máximo 1 TTL. */
  async renew(lessonId: string, sessionId: string): Promise<SasGrant> {
    const { data } = await apiService.post<SasGrant>(`${base(lessonId)}${sessionId}/renew/`);
    return data;
  },

  /** Compõe, valida e publica. 202 = o servidor assumiu; consulte o status. */
  async commit(
    lessonId: string,
    sessionId: string,
    title: string
  ): Promise<{ finalizing: boolean; video: AttachedVideo | null; lesson: unknown }> {
    const response = await apiService.post<CommitResponse>(
      `${base(lessonId)}${sessionId}/commit/`,
      { title }
    );
    if (response.status === 202) {
      return { finalizing: true, video: null, lesson: null };
    }
    const data = response.data as AttachedVideo & { lesson: unknown };
    return { finalizing: false, video: data, lesson: data.lesson };
  },

  async cancel(lessonId: string, sessionId: string): Promise<void> {
    await apiService.delete(`${base(lessonId)}${sessionId}/`);
  },
};
